import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { APP_DIALOG_DATA } from '../../../shared/components/dialog/dialog.tokens';
import { AppDialogRef } from '../../../shared/components/dialog/dialog-ref';
import { DIALOG_IMPORTS } from '../../../shared/components/dialog/dialog.imports';
import { AnalyticsService } from '../../../_services/analytics.service';
import { CopilotRecipient } from '../../../_interfaces/document';

export interface RecipientManualDialogData {
  mode: 'primary' | 'cc';
  templateId?: number;
  initialContent?: string;
}

@Component({
  selector: 'app-recipient-manual-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TranslateModule,
    ...DIALOG_IMPORTS,
  ],
  templateUrl: './recipient-manual.component.html',
})
export class RecipientManualDialogComponent {
  content = '';

  constructor(
    private dialogRef: AppDialogRef<RecipientManualDialogComponent, CopilotRecipient | undefined>,
    @Inject(APP_DIALOG_DATA) public data: RecipientManualDialogData,
    private translate: TranslateService,
    @Optional() private analytics: AnalyticsService | null = null,
  ) {
    if (data.initialContent != null) {
      this.content = data.initialContent;
    }
  }

  get isEdit(): boolean {
    return this.data.initialContent != null;
  }

  get title(): string {
    return this.isEdit
      ? this.translate.instant('Edit free text recipient')
      : this.translate.instant('Add free text recipient');
  }

  get canSave(): boolean {
    return this.content.trim().length > 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (!this.canSave) return;
    const content = this.content.trim();
    this.analytics?.track(this.isEdit ? 'free_text_recipient_edited' : 'free_text_recipient_added', {
      surface: 'web_document',
      ...(this.data.templateId != null ? { blueprint_id: String(this.data.templateId) } : {}),
      recipient_type: this.data.mode,
      char_count: content.length,
    });
    this.dialogRef.close({
      content,
      changed: true,
    });
  }
}
